import angular from 'angular';
import { requestPrinterlessReturnInfo } from '../actions/printerlessInfo';
import { store } from '../store';

angular.module('PrinterlessInfoController', []).controller('PrinterlessInfoController', [
  () => {
    store.dispatch(requestPrinterlessReturnInfo());
  },
]);
